define('app/views/reset_password_view',['app/setup'], function(takhfifan) {
  takhfifan.resetPasswordView = Backbone.View.extend({
    events: {
      'submit' : 'submitForm',
    },
    initialize: function() {
      Backbone.Validation.bind(this);
      this.resetFormSubmitted=false;
    },
    submitForm: function(evt) {
      if(!this.resetFormSubmitted) {
        evt.preventDefault();
        var _this=this;
        this.model.set({
          password: this.$("#password").val(),
          confirmation: this.$("#confirmation").val()
        }, { validate: true });
        if(this.model.isValid()) {
          if(!this.resetFormSubmitted) {
            this.resetFormSubmitted=true;
            this.$('#tkhResetForm').submit();
          }
        }
      }
    }
  });
});

